import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer, ToastContainerProps } from "react-toastify";
import { useWssNotifications } from "../hooks/useWssNotifications";
import { useEffect } from "react";
import {
    getNotificationShowedToasts,
    getNotificationToast,
    getShowedMessage,
    getShowMessagesQueueLength
} from "../notificationsSelectors";
import { useDispatch, useSelector } from "react-redux";
import {
    closeNotificationFromQueueAction,
    closeNotificationToastAction,
    openNotificationToastAction,
    showNotificationFromQueueAction
} from "../notificationsReducer";
import { ToastOptions } from "react-toastify/dist/types";
import { useLocation } from "react-router";

type INotificationsProviderProps = ToastContainerProps;

function NotificationsProvider(props: INotificationsProviderProps) {

    useWssNotifications();

    const showMessagesQueueLength = useSelector(getShowMessagesQueueLength);
    const showedMessage = useSelector(getShowedMessage);
    const showedToasts = useSelector(getNotificationShowedToasts);
    const dispatch = useDispatch();
    const notificationToast = useSelector(getNotificationToast);
    const { search } = useLocation();

    useEffect(() => {
        if (showedMessage) {
            const params = new URLSearchParams(search);
            if (!params.getAll('s').includes(showedMessage.type)) {
                dispatch(closeNotificationFromQueueAction());
            }
        }
    }, [dispatch, search, showedMessage]);

    useEffect(() => {
        if (!showedToasts.length && !showedMessage && showMessagesQueueLength) {
            dispatch(showNotificationFromQueueAction());
        }
    }, [dispatch, showMessagesQueueLength, showedMessage, showedToasts]);

    useEffect(() => {
        const { content, options } = notificationToast || {};
        if (notificationToast) {
            const toastId = toast(content, {
                ...options,
                onClose: (toast: {
                    toastProps: ToastOptions,
                }) => {
                    dispatch(closeNotificationToastAction(toastId));
                }
            });
            dispatch(openNotificationToastAction(toastId as string));
        }
    }, [dispatch, notificationToast]);

    return <ToastContainer
        hideProgressBar
        position="bottom-right"
        theme="dark"

        {...props}

    />
}

export default NotificationsProvider;
